import gql from 'graphql-tag';

export default gql`
  fragment articleFragment on Article {
    id
    url
    publishedDate
  }
`;
